<template>
  <li
    :class="{ 'steps-links--current': isCurrentStep, 'steps-links--active': isActive }"
    class="steps-links"
  >
    <a
      :href="step.route"
      class="steps-links__anchor"
    >
      <svg>
        <use
          :xlink:href="`#${stepIcons[step.order - 1]}`"
        ></use>
      </svg>
      <span>&nbsp;{{ step.label }}</span>
    </a>
    <svg class="steps-links__arrow">
      <use xlink:href="#icon-arrow2"></use>
    </svg>
  </li>
</template>

<script>
export default {
  props: {
    step: {
      type: Object,
      required: true,
    },
    currentStep: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      stepIcons: [
        'icon-car',
        'icon-settings',
        'icon-user',
        'icon-list',
        'icon-validation',
      ],
    }
  },
  computed: {
    isCurrentStep() {
      return this.currentStep === this.step.order
    },
    isActive() {
      if (this.currentStep === 5) return this.currentStep <= this.step.order
      return this.currentStep >= this.step.order
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../_src/sass/config/vars';
@import '../../../../../_src/sass/config/mixins';
@import '../../../../../_src/sass/config/responsive';

.steps-links {
  align-content: center;
  align-items: center;
  display: flex;
  font-family: $f-graphie-semibold;
  opacity: 0.5;
  padding: 5px 10px;
  pointer-events: none;
  position: relative;

  &--active {
    opacity: 1;
    pointer-events: all;
  }

  &:first-child {
    padding: 0 10px 0 0;
  }

  @include teq-breakpoint($medium) {
    padding: 0 20px;

    &:first-child {
      padding: 0 20px 0 10px;
    }
  }

  &__anchor {
    @include sharedNavAnchor();

    align-items: center;
    counter-increment: counter-steps;
    display: flex;
    justify-content: center;

    &::before {
      content: counter(counter-steps) ': ';

      @include teq-breakpoint($medium) {
        content: '';
      }
    }

    .steps-links--current &,
    &:hover {
      &::after {
        background-color: $orange;
        bottom: 0;
        content: '';
        height: 2px;
        left: 0;
        position: absolute;
        width: 100%;

        @include teq-breakpoint($medium) {
          content: '';
        }
      }
    }

    .steps-links--current &,
    &:hover {
      span {
        &::after {
          background-color: $orange;
          bottom: 0;
          content: ' ';
          height: 2px;
          left: 0;
          position: absolute;
          width: 100%;
        }
      }
    }

    svg {
      margin-right: 0;
      max-height: 20px;
      max-width: 20px;

      @include teq-breakpoint($medium) {
        margin-right: 10px;
      }
    }

    span {
      display: none;

      .steps-links--current & {
        display: flex;
      }

      &::before {
        content: counter(counter-steps) ': ';

        .steps-links--current & {
          content: '';

          @include teq-breakpoint($medium) {
            content: counter(counter-steps) ': ';
          }
        }
      }

      @include teq-breakpoint($medium) {
        display: flex;
      }
    }
  }

  &__arrow {
    max-height: 10px;
    max-width: 10px;
    position: absolute;
    right: -6px;

    @include teq-breakpoint($medium) {
      max-height: 12px;
      max-width: 12px;
    }
  }

  &:last-child {
    .steps-links__arrow {
      display: none;
    }
  }
}
</style>
